import { action, observable, makeObservable } from 'mobx';
import { enableStaticRendering } from 'mobx-react';
import { cache, getLANG, handleQueryParams, isEmpty } from '@/utils';
import { httpRequest } from '@/request';
import { SERVER } from '@/request/config';
import StoreBase from './Base';

// eslint-disable-next-line react-hooks/rules-of-hooks
enableStaticRendering(typeof window === 'undefined');

class Area extends StoreBase {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  @observable
  listCountryInfos = {};

  @observable
  areaMap = [];

  @observable
  allCountry = [];

  @observable
  country = {};

  @action
  setStateValue = (state, value) => {
    this[state] = value;
  };

  @observable
  freeShippingPrice = { signal: '', amount: '', currency: '' };

  @observable
  areaNavigationVisible = false; // 移动端提示国家选择横幅

  @observable
  areaModalVisible = false;

  @action
  toggleAreaModal = (areaModalVisible) => {
    this.areaModalVisible = typeof areaModalVisible !== 'object' ? areaModalVisible : !this.areaModalVisible;
    if (areaModalVisible) {
      this.areaNavigationVisible = false;
    }
  };

  @observable
  LANG = getLANG() ?? {};

  // 移动端初始化页面时判断是否展示选择地区横幅
  @action
  initAreaNavigation = () => {
    if (typeof window !== 'undefined' && this.root.app.isMobile) {
      const hasShown = cache.get('region_modal') === '1';
      const notShowHref = /^(\/order\/)|^(\/center\/)|^(\/app\/)/.test(window.location.pathname);
      if (!hasShown && !notShowHref && !isEmpty(this.country)) {
        this.areaNavigationVisible = true;
      }
    }
  };

  @action
  initListCountry() {
    // 停止运营地区，service COUNTRY_LIST 要移除；
    // 同时disabledAreaList要新增该地区
    const disabledAreaList = ['RU'];
    const dataMap = this.listCountryInfos;
    let areaMap = [];
    let allCountry = [];
    // eslint-disable-next-line guard-for-in
    for (const key in dataMap) {
      if (Object.prototype.hasOwnProperty.call(dataMap, key)) {
        areaMap.push({
          name: key,
          list: dataMap[key].filter((o) => !disabledAreaList.includes(o.code)),
        });
      }
      if (key !== 'COMMON') {
        allCountry.push(...dataMap[key]);
      }
    }
    allCountry = allCountry.sort((prev, next) => (prev.code > next.code ? 1 : -1));
    this.areaMap = areaMap;
    this.allCountry = allCountry;
  }

  @action
  setCountry = (country) => {
    const { code, currency, currency_signal, language } = country;

    // 避免字符编码导致异常，所以Encode，读取再Decode
    cache.setCookie('X_Country_Code', encodeURIComponent(code));
    cache.setCookie('X_Language', encodeURIComponent(language.toLowerCase()));
    cache.setCookie('X_Currency', encodeURIComponent(currency));
    cache.setCookie('X_Currency_Signal', encodeURIComponent(currency_signal));

    // 若参数携带X-Country，则移除
    window.history.replaceState?.({}, null, handleQueryParams('X-Country'));

    // 刷新页面
    window.location.reload();
  };

  @observable
  provinceCityMap = {};

  @action
  fetchProvinceCity = (provinceAdCode) => {
    return new Promise((resolve) => {
      if (this.provinceCityMap[provinceAdCode]) {
        resolve(this.provinceCityMap[provinceAdCode]);
        return;
      }
      httpRequest({
        url: `${SERVER.API_SERVER_INFR_BASE}/service/dataDict/getByTypeAndCode?language=zh_CN&dataType=common.country.cn_area_official&dataCode=${provinceAdCode}`,
      }).then(({ data }) => {
        const cityData = data[0]['children'];
        cityData.forEach((o) => {
          o.AdCode = o.dataCode;
          o.name = o.dataValue;
          o.children = o.children || [];
          o.children.forEach((c) => {
            c.AdCode = c.dataCode;
            c.name = c.dataValue;
          });
        });
        this.provinceCityMap[provinceAdCode] = cityData;
        resolve(cityData);
      });
    });
  };
}

export default Area;
